module.exports = __webpack_public_path__ + "static/media/img-heritage-area8-yahata01.dd5168e3.jpg";